/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('site.tableBookingModal', [
        'https://static.stefna.is/js/micromodal/0.4.10/micromodal.min.js',
        '/_moya/styles/libs/micromodal.css',
        '/_moya/styles/libs/awn.css'
    ], function (el) {
        var url = el.dataset.href;
        var modal = MoyaContainer.get('core.modal');
        if (!url) {
            console.error('data-href attribute not set');
            return;
        }
        el.addEventListener('click', function () {
            modal.open(url, {
                preventBodyScroll: true,
                disableOverlayClose: true,
            }).then(function (modal) {
                var modalElement = modal.element;
                var buttons = modalElement.querySelectorAll('[href]');
                buttons.forEach(function (button) {
                    button.addEventListener('click', function (ev) {
                        ev.preventDefault();
                        modalElement.innerHTML = '';
                        modalElement.innerHTML = "\n\t\t\t\t\t\t<div class=\"modal-back-wrapper\">\n\t\t\t\t\t\t\t<button class=\"btn btn-primary\">Til baka</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"iframe__wrapper\">\n\t\t\t\t\t\t\t<iframe src=\"" + button.getAttribute('href') + "\" onload=\"iframeLoaded()\"></iframe>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t";
                        var backButton = modalElement.querySelector('.modal-back-wrapper > button');
                        backButton.addEventListener('click', function (ev) {
                            modal.close();
                            el.dispatchEvent(new Event('click'));
                        });
                    });
                });
            });
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
